// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"654ec774","239":"d76642f8","455":"69a282cb"}[chunkId] + ".chunk.js";
};